import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import TabsList from "./TabsList";

export const TASK_TAB_DASHBOARD = "dashboard";
export const TASK_TAB_MANAGEMENT = "management";
export const TASK_TAB_TIME_BLOCKING = "time_blocking";

/**
 * Cross-route tabs between Task Dashboard, Task Management, and Time Blocking.
 */
export default function TaskSectionTabs({ activeTab }) {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const showDashboard = hasPermission && hasPermission("menu.task_dashboard");
  const showManagement = hasPermission && hasPermission("menu.task");
  const showTimeBlocking = hasPermission && hasPermission("menu.time_blocking");

  return (
    <TabsList className="section-tabs-list" role="tablist" aria-label="Task sections">
      {showDashboard ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === TASK_TAB_DASHBOARD}
          className={`tab-btn ${activeTab === TASK_TAB_DASHBOARD ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== TASK_TAB_DASHBOARD) navigate("/Dashboard?view=simple");
          }}
        >
          Task Dashboard
        </button>
      ) : null}
      {showManagement ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === TASK_TAB_MANAGEMENT}
          className={`tab-btn ${activeTab === TASK_TAB_MANAGEMENT ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== TASK_TAB_MANAGEMENT) navigate("/Task");
          }}
        >
          Task Management
        </button>
      ) : null}
      {showTimeBlocking ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === TASK_TAB_TIME_BLOCKING}
          className={`tab-btn ${activeTab === TASK_TAB_TIME_BLOCKING ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== TASK_TAB_TIME_BLOCKING) navigate("/TimeBlocking");
          }}
        >
          Time Blocking
        </button>
      ) : null}
    </TabsList>
  );
}
